/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react';
import 'moment/locale/pt';

import moment from 'moment'
import { Box, Button, FormControl,TextField, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { DatePicker } from '@mui/x-date-pickers';
import styled from 'styled-components';
import { enqueueSnackbar } from 'notistack';

export default function filterModal({ onClose, setFilter, clearCupons, setFilterValues }) {
  // Filter tab you are currently at.
  const [tab, setTab] = useState('cpf');
  // Dates are a pain!
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  
  const [cpf, setCpf] = useState(null);
  const [cpr_number, setCprNumber] = useState(null);

  const formatDate = (date) => {
    return moment.utc(new Date(date)).format('DD/MM/YYYY')
  }

  /** Returns filter values to perform database search. */
  const handleReturn = () => {

    if (tab === 'cpf') {
      if(cpf) {
        setFilterValues(`&cpf=${cpf}`);
      } else {
        enqueueSnackbar('Digite o CPF!', { variant: 'info' });
        return
      }
    }

    if (tab === 'cpr') {
      if(cpr_number) {
        setFilterValues(`&cpr_number=${cpr_number}`);
      } else {
        enqueueSnackbar('Digite o número da CPR!', { variant: 'info' });
        return
      }
    }

    if (tab === 'date') {
      if (startDate && endDate) {
        if(!validateEndDate()) { return; }

        const start = getDateForComparison(startDate);
        const end = getDateForComparison(endDate);

        // Date is formatted YYYY-MM-DD for database query.
        const s = `${start.year}-${start.month}-${start.day}`;
        const e = `${end.year}-${end.month}-${end.day}`;
        setFilterValues(`&date_start=${s}&date_end=${e}`);
      } else {
        enqueueSnackbar('Selecione as duas datas!', { variant: 'info' });
        return
      }

    }
    //clearCupons()
    setFilter(true)
    onClose()
    moment.locale('en')
  }

  const Label = styled(Typography)(({ theme }) => ({
    '&': {
      fontSize: '16px',
      marginBottom: '10px'
    },
  }))

  //#region ========== Filter Stuff ==========

  const clearFilters = () => {
    setCpf(null);
    setCprNumber(null);
    setEndDate(null);
    setStartDate(null);
  }

  const filterTabs = () => {
    return (
      <Box sx={{
        borderBottom: "1em",
        borderColor: 'divider'
      }}>
        <Button onClick={() => {
          clearFilters();
          setTab('cpf');
        }}>
          CPF
        </Button>

        <Button onClick={() => {
          clearFilters();
          setTab('cpr');
        }}>
          CPR
        </Button>

        <Button onClick={() => {
          clearFilters();
          setTab('date');
        }}>
          Data
        </Button>
        
      </Box>
    );
  }

  const filterByCpf = () => {
    if(tab !== 'cpf') {
      return<></>;
    }

    return (
      <Box>
        <Label>Entre o CPF</Label>
        <FormControl fullWidth>
          <TextField
            id="investor-cpf"
            label="CPF"
            value={cpf}
            onChange={(event) => {
              setCpf(event.target.value);
            }}
          />
        </FormControl>
      </Box>
    );
  }

  const filterByCprNumber = () => {
    if(tab !== 'cpr') {
      return<></>;
    }

    return (
      <Box>
        <Label>Entre o numero da CPR</Label>
        <FormControl fullWidth>
          <TextField
            id="cpr-number"
            label="CPR"
            value={cpr_number}
            onChange={(event) => {
              setCprNumber(event.target.value);
            }}
          />
        </FormControl>
      </Box>
    );
  }

  const filterByDate = () => {
    if(tab !== 'date') {
      return<></>;
    }

    return(
      <Box>
        <Label>Entre as datas</Label>
        <DatePicker
          sx={{margin: '10px 0'}}
          label="Data inicial"
          value={startDate}
          format="DD/MM/YYYY"
          onChange={(newValue) => setStartDate(newValue)}
        />
        <DatePicker
          sx={{margin: '10px 0'}}
          label="Data final"
          value={endDate}
          format="DD/MM/YYYY"
          onChange={(newValue) => setEndDate(newValue)}
        />
      </Box>
    );
  }

  //#endregion

  //#region ========== Date Stuff ==========

  /** Use to get an object with the date ... because comparing dates sucks!
   * @return date object {day:day, month:month, year:year}
   */
  const getDateForComparison = (date) => {
    const fullDate = new Date(date);
    const year = fullDate.getFullYear();
    // Month is base zero!!! Why???
    const month = fullDate.getMonth() + 1;
    const day = fullDate.getDate();

    return {day:day, month:month, year:year};
  }

  /** Only use this with values from getDateForComparison */
  const isFirstDateSmallerOrEqual = (d1, d2) => {
    if(d1.year > d2.year) {return false;}
    if(d1.year < d2.year) {return true;}
    if(d1.month > d2.month) {return false;}
    if(d1.month < d2.month) {return true;}
    if(d1.day > d2.day) {return false;}
    return true;
  }

  /** End date needs to be after start date. */
  const validateEndDate = () => {
    if (!endDate) { return false; }
    if (!startDate) { return false; }

    const start = getDateForComparison(new Date(startDate));
    const end = getDateForComparison(new Date(endDate));

    if (!isFirstDateSmallerOrEqual(start, end)) {
      console.log('End date needs to be after start date or the same.');
      enqueueSnackbar('A data final deve ser posterior a data inicial!', { variant: 'error' });
      return false;
    }
    return true;
  }

  //#endregion

  const buttonsBottom = () => {
    return (
      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
        gap: 1,
        padding: 2,
        borderRadius: '0 0 8px 8px',
        backgroundColor: '#fff'
      }}>
        <Button variant="contained" color={'success'} onClick={() => handleReturn()}>
          <Typography color={'#fff'}>
            Filtrar
          </Typography>
        </Button>
        
        <Button variant="contained" onClick={onClose}>
          <Typography color={'#fff'}>
            Fechar
          </Typography>
        </Button>
      </Box>
    );
  }

  const pageTitle = () => {
    return(
      <Box sx={{
        padding: '16px',
        borderRadius: '8px 8px 0 0',
        backgroundColor: '#fff'
      }}>
        <Typography variant="h6" component="h2">
          Filtros
        </Typography>
      </Box>
    );
  }

  const pageBody = () => {
    return (
      <Box sx={{
        margin: '1em',
        width: '25em',
        height: '100%',
        backgroundColor: '#fff',
        borderRadius: 1,
      }}>
        {filterTabs()}
        <Box sx={{
          marginLeft:'1em',
          borderBottom:'.5em',
          width: '90%',
        }}>
          {filterByCpf()}
          {filterByCprNumber()}
          {filterByDate()}
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow: 24,
      borderRadius: 2,
      backgroundColor: grey[300]
    }}>
      {pageTitle()}
      {pageBody()}
      {buttonsBottom()}
    </Box>
  )
}
